/* ==========================================================
   Testimonials: slider height follows the CURRENT review
   (so the arrows sit right under the text/products instead of
   under the tallest review), and less space above the arrows.
   ========================================================== */
(function () {
  var css =
    '.testimonials .slider__grid{align-items:flex-start!important;transition:height .35s ease}' +
    '.testimonials .slider-buttons-items--bottom{padding-top:32px!important}';
  var style = document.createElement('style');
  style.textContent = css;
  document.head.appendChild(style);

  function setup(section) {
    var ul = section.querySelector('.slider__grid');
    if (!ul || ul.dataset.fitHeight) return;
    ul.dataset.fitHeight = '1';
    var items = Array.prototype.slice.call(ul.children);
    if (items.length < 2) return;

    function fit() {
      var base = items[0].offsetLeft;
      var best = items[0], bestDist = Infinity;
      items.forEach(function (li) {
        var d = Math.abs(li.offsetLeft - base - ul.scrollLeft);
        if (d < bestDist) { bestDist = d; best = li; }
      });
      var card = best.querySelector('.testimonials_card') || best;
      ul.style.height = card.offsetHeight + 'px';
    }

    var t;
    ul.addEventListener('scroll', function () {
      clearTimeout(t);
      t = setTimeout(fit, 60);
    }, { passive: true });
    window.addEventListener('resize', function () {
      ul.style.height = '';
      clearTimeout(t);
      t = setTimeout(fit, 120);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(function () { fit(); }).observe(items[0]);
    }
    window.addEventListener('load', fit);
    fit();
  }

  function init() {
    document.querySelectorAll('.testimonials').forEach(setup);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();

/* ==========================================================
   Product cards (collection grid hover_behavior = slider):
   - Touch devices: swipe through all images (theme default).
   - Mouse devices: keep the classic hover -> second image
     (same theme classes as "second image" mode); no arrows,
     dots or drag, and the slider never takes over.
   ========================================================== */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  var SEL = 'swiper-gallery.swiper-product-card--slider';

  var style = document.createElement('style');
  style.textContent =
    SEL + ' .swiper-button,' + SEL + ' .swiper-pagination{display:none!important}';
  document.head.appendChild(style);

  function enhance(g) {
    if (g.dataset.spHover) return;
    g.dataset.spHover = '1';
    var tpl = g.querySelector('template.all-product-card-images-template');
    var box = g.querySelector('li.swiper-slide .card__product-image');
    if (!tpl || !tpl.content || !box) return;
    var slides = tpl.content.querySelectorAll('li.swiper-slide');
    if (slides.length < 2) return;
    var src = slides[1].querySelector('img');
    if (!src) return;
    var img = src.cloneNode(true);
    img.className = 'card__image card__image--second';
    img.setAttribute('loading', 'lazy');
    img.setAttribute('draggable', 'false');
    box.appendChild(img);
    box.classList.add('card__product-image--show-second', 'have-second-media');
    var pci = box.closest('product-card-image');
    if (pci) pci.setAttribute('show-second-media', 'true');
  }

  function scan(root) {
    (root || document).querySelectorAll(SEL).forEach(enhance);
  }

  // Stop the slider from loading/sliding on mouse hover, click-drag.
  ['mouseenter', 'pointerdown', 'mousedown'].forEach(function (type) {
    document.addEventListener(type, function (e) {
      var el = e.target;
      if (!el || !el.closest) return;
      if (type === 'mouseenter' ? (el.matches && el.matches(SEL)) : el.closest(SEL)) {
        e.stopPropagation();
      }
    }, true);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { scan(); });
  } else {
    scan();
  }
  if (window.MutationObserver) {
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      setTimeout(function () { queued = false; scan(); }, 200);
    })
      .observe(document.documentElement, { childList: true, subtree: true });
  }
})();
